// Here we build routes that will be attached to menus
// We can use the state value login/loggedinUser and
// login/loggedinOrg to get dependenicies and other
// values specific to this user and org
import { sync } from 'vuex-pathify'
// import Vue from 'vue'
// const Table = () => import('@/../../coreui/components/ServerTable')
import cultivationMenu from './menus/cultivation.js'
import dashboardMenu from './menus/dashboards.js'
import calendarMenu from './menus/calendar.js'
import distributionMenu from './menus/distribution.js'
import sensorsMenu from './menus/sensors.js'
import manufacturingMenu from './menus/manufacturing.js'
import testingMenu from './menus/testing.js'
import financeMenu from './menus/finance.js'
import metrcMenu from './menus/metrc.js'
import metrcUIMenu from './menus/metrcUI.js'
import superMenu from './menus/super.js'
import settingsMenu from './menus/settings.js'
import facilitiesMenu from './menus/facilities.js'
import messagingMenu from './menus/messaging.js'
import helpMenu from './menus/help.js'
import crmMenu from './menus/crm.js'
import policyMenu from './menus/policy.js'
import documentsMenu from './menus/documents.js'
import visitorMenu from './menus/visitors.js'
import opsMenu from './menus/operations.js'

import cultivationRoutes from './routes/cultivation.js'
import dashboardRoutes from './routes/dashboards.js'
import calendarRoutes from './routes/calendar.js'
import metrcRoutes from './routes/metrc.js'
import metrcUIRoutes from './routes/metrcUI.js'
import superRoutes from './routes/super.js'
import settingsRoutes from './routes/settings.js'
import facilitiesRoutes from './routes/facilities.js'
import testingRoutes from './routes/testing.js'
import financeRoutes from './routes/finance.js'
import distributionRoutes from './routes/distribution.js'
import messagingRoutes from './routes/messaging.js'
import helpRoutes from './routes/help.js'
import crmRoutes from './routes/crm.js'
import policyRoutes from './routes/policy.js'
import documentsRoutes from './routes/documents.js'
import visitorRoutes from './routes/visitors.js'
import opsRoutes from './routes/operations.js'
import axiosInstances from '@/../../coreui/server/axiosInstances.js'

const Workflows = () => import('@/../../cortex/src/components/workflowViewer/Workflows')

const PageFound = () => import('@/components/errors/PathForward')

export default {
  methods: {
    checkExistingRoute(curRoutes, newroute) {
      let stat = false
      // return stat
      if (curRoutes != null) curRoutes.forEach(i => {
        if (i.path == newroute.path) {
          stat = true
          return stat
        }
      })
      return stat
    },
    async buildMainMenu (allowed) {
      console.log('BuildMenu allowed: ', allowed)
      let menu = []
      menu = menu
        .concat(dashboardMenu(allowed))
        .concat(sensorsMenu(allowed))
        .concat(calendarMenu(allowed))
        .concat(messagingMenu(allowed))
        .concat(cultivationMenu(allowed))
        .concat(distributionMenu(allowed))
        .concat(testingMenu(allowed))
        .concat(financeMenu(allowed))
        .concat(metrcMenu(allowed))
        .concat(metrcUIMenu(allowed))
        .concat(crmMenu(allowed))
        .concat(visitorMenu(allowed))
        .concat(facilitiesMenu(allowed))
        .concat(policyMenu(allowed))
        .concat(documentsMenu(allowed))
        .concat(opsMenu(allowed))
        .concat(settingsMenu(allowed))
    
      if (this.loggedinUser.role == 'super') {
        menu = menu.concat(superMenu())
      }
      menu = menu.concat(helpMenu(allowed))
      console.log('Built Menu: ', menu)
      menu = await this.buildWorkflowMenus(menu)
      return menu
    },

    // get all allowed workflows for the org
    async findAllowedWorkflows() {
      let workflows = []
      let allowed = await axiosInstances.loginServer.get('/dt/v1/org?return=wid&name='+this.origLoggedinOrg.name)
      // let masterModules = await axiosInstances.loginServer.get('/dt/v1/sup_modules?return=name&return=code')
      allowed = allowed.data && allowed.data[0] && allowed.data[0].wid ? allowed.data[0].wid : []
      console.log('Allowed workflow ids: ', allowed)
      let masterWFList = await axiosInstances.loginServer.get('/dt/v1/auth_workflows')
      workflows = masterWFList.data
      workflows = masterWFList.data.filter((i) => { if (allowed.includes(i._id))  return i})
      console.log('Allowed workflows: ', workflows)
      return workflows
    },

    // get a list of modules with id, name and code, for which workflows exist
    async getWorkflowModules(workflows) {
      let modules = []
      workflows.forEach((i) => {
        modules = modules.concat(i.module)
      })
      modules = [...new Set(modules)]
      console.log('Workflow Modules: ', modules)
      // let pipeline = [
      //   {"$addFields": { "strId": {"$toString": "$_id"}}},
      //   {"$match": {"$expr": { "$in": ["$strId", modules]}}},
      //   {"$project": {
      //     "code" : 1,
      //     "name": 1
      //   }}
      // ]
      // let url = '/misc/dbops?c=sup_modules&op=pipe'
      // let res = await axiosInstances.loginServer.post(url, pipeline)
      // return res == null || res.data == null ? [] : res.data
      let allModules = await axiosInstances.loginServer.get('/dt/v1/sup_modules')
      let res = []
      allModules.data.forEach((i) => {
        if (modules.includes(i._id)) res.push(i)
      })
      console.log('RES: ',res)
      return res
    },

    async buildWorkflowMenus(menu) {
      let wf = await this.findAllowedWorkflows()
      let modules = await this.getWorkflowModules(wf)
      let modNameArray = modules.map( i => i.name)
      let modCodeArray = modules.map(i => i.code)
      console.log('modNameArray: ', modNameArray, modCodeArray)
      menu.forEach(async (m) => {
        if (modNameArray.includes(m.title) || modCodeArray.includes(m.code)) {
          await this.addWorkFlowToMenu(m)
          console.log('Added workflow: ', m)
        } else {
          console.log('No workflows for ', m)
        }
      })
      return menu
    },

    async addWorkFlowToMenu(menu) {
      console.log('Adding workflow to menu: ', menu.title)
      let allowed = await axiosInstances.loginServer.get('/dt/v1/org?return=wid&name='+this.origLoggedinOrg.name)
      allowed = allowed.data && allowed.data[0] ? allowed.data[0].wid : []
      let r = {
        name: menu.title + 'Workflows',
        path: '/' + menu.title + 'Workflows',
        component: Workflows,
        props: {ids: allowed, module: menu.title}
      }
      this.$router.addRoute(r)
      menu.items.unshift(
        {title: 'Workflows', icon: 'mdi-clipboard-flow', path: '/' + menu.title + 'Workflows'}
      )
    },

    async buildRoutes (allowed) {
      console.log('BuildRoutes allowed: ', allowed)
      let routes = []
      routes = routes
        .concat(cultivationRoutes(allowed))
        .concat(dashboardRoutes(allowed))
        .concat(calendarRoutes(allowed))
        .concat(metrcRoutes(allowed))
        .concat(metrcUIRoutes(allowed))
        .concat(testingRoutes(allowed))
        .concat(financeRoutes(allowed))
        .concat(distributionRoutes(allowed))
        .concat(messagingRoutes(allowed))
        .concat(crmRoutes(allowed))
        .concat(facilitiesRoutes(allowed))
        .concat(opsRoutes(allowed))
        .concat(settingsRoutes(allowed))
        .concat(policyRoutes(allowed))
        .concat(documentsRoutes(allowed))
        .concat(visitorRoutes(allowed))
  
      if (this.loggedinUser.role == 'super') {
        routes = routes.concat(superRoutes())
      }
      routes = routes.concat(helpRoutes(allowed))
      let curRoutes = this.$router.getRoutes()
      routes.forEach((i) => {
        if (!this.checkExistingRoute(curRoutes, i)) {
          this.$router.addRoute(i)
        }
      })
    }
  }
}